//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fushiCamera from './fushiCamera'
import reminCamera from './reminCamera'
export default {
  data () {
    return {
      index: true,
      fushiCamera: false,
      reminCamera: false
    }
  },
  components: {
    fushiCamera,
    reminCamera
  },
  methods: {
    showDetail (param) {
      this.selectedDetail = param
      this.$router.push({name: 'blankPage', params: {selectedDetail: this.selectedDetail}})
    }
  },
  created () {
    // console.log('11111111111111111111', )
    if (this.$route.params.selectedDetail === 'plus') {
      this.fushiCamera = true
      this.reminCamera = false
      this.index = false
    } else if (this.$route.params.selectedDetail === 'remin') {
      this.fushiCamera = false
      this.reminCamera = true
      this.index = false
    } else {
      this.fushiCamera = false
      this.reminCamera = false
      this.index = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/filmSelfPrinter/index.vue